exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".list-group{line-height:21px;color:#87a6bc;font-family:Open Sans,Helvetica,Arial,sans-serif;text-transform:uppercase;border-top:1px solid #87a6bc;border-bottom:1px solid #87a6bc;margin-top:6px;margin-bottom:6px;padding:6px 0;font-weight:600;font-size:11px;vertical-align:baseline}.list-group svg{fill:#87a6bc;height:16px;width:16px;position:relative;top:4px;margin-right:4px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./~/autoprefixer-loader!./src/list-view-layout.scss
 ** module id = 388
 ** module chunks = 0
 **/